import script from "./RfidPieceupPage.vue?vue&type=script&setup=true&lang=js"
export * from "./RfidPieceupPage.vue?vue&type=script&setup=true&lang=js"

import "./RfidPieceupPage.vue?vue&type=style&index=0&id=583a17dc&scoped=true&lang=css"

import exportComponent from "/home/marco/docker-devs/laundryrepublic/codebase/lr-epos2-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-583a17dc"]])

export default __exports__